(function () {
    'use strict';

    angular
        .module('core.services')
        .service('ApplicationAuthService', ApplicationAuthService)

    /** @ngInject */
    function ApplicationAuthService(LOCAL_STORAGE_ITEMS) {
        let application;

        const ApplicationAuthService = {
            setAuthTry: setAuthTry,
            resetAuth: resetAuth,
            isAuthValid: isAuthValid
        }

        return ApplicationAuthService;

        // Methods
        function setAuthTry(applicationClientId) {
            if (!application)
                configureApplication();

            if (application.ClientId == applicationClientId)
                application.Tries++;
            else {
                application = {
                    ClientId: applicationClientId,
                    Tries: 1
                }

                saveAuthExpiration();
            }

            saveApplication();
        }

        function resetAuth() {
            application = null;
            localStorage.removeItem(LOCAL_STORAGE_ITEMS.APPLICATION_AUTH);
            localStorage.removeItem(LOCAL_STORAGE_ITEMS.APPLICATION_AUTH_EXPIRATION);
        }

        function isAuthValid() {
            if (!application)
                configureApplication();

            return !application.ClientId || (application && application.Tries < 5);
        }

        // Internal
        function configureApplication() {
            const storageApplication = localStorage.getItem(LOCAL_STORAGE_ITEMS.APPLICATION_AUTH);

            application = {};

            if (storageApplication)
                application = JSON.parse(storageApplication);
        }

        function saveApplication() {
            const parsedApplication = JSON.stringify(application);
            const authExpiration = localStorage.getItem(LOCAL_STORAGE_ITEMS.APPLICATION_AUTH_EXPIRATION);

            if (authExpiration && moment().diff(authExpiration, 'minutes') > 0) {
                application = null;
                localStorage.removeItem(LOCAL_STORAGE_ITEMS.APPLICATION_AUTH);
                localStorage.removeItem(LOCAL_STORAGE_ITEMS.APPLICATION_AUTH_EXPIRATION);
                return;
            }

            localStorage.setItem(LOCAL_STORAGE_ITEMS.APPLICATION_AUTH, parsedApplication);
        }

        function saveAuthExpiration() {
            const authExpiration = moment().add(15, 'minutes').format('YYYY-MM-DD HH:mm:ss');

            localStorage.setItem(LOCAL_STORAGE_ITEMS.APPLICATION_AUTH_EXPIRATION, authExpiration);
        }
    }
}());